module.exports = __webpack_public_path__ + "img/ordF4.b541b402.jpg";